<template>
  <div class="containerMod">
    <div class="pubRow" v-for="congreso in congresosShow" :key="congreso._id">
      <div class="organizador">{{congreso.organizador}}</div>
      <div class="restoDatos">
        <div class="datosCong">
          <div class="nombre">{{congreso.nombre}}</div>
          <div class="line2">
            {{congreso.lugar}}
          </div>
          <div class="line2">
            {{congreso.ciudad}} - {{congreso.pais}} | {{congreso.fecha}}
          </div>
        </div>
        <div class="selector" v-show="!aislar"
          @click="aislarCongreso(congreso._id)">&dtrif;
        </div>
        <div class="selector" v-show="aislar"
          @click="retornoCongreso()">&ltrif;
        </div>
      </div>
    </div>
    <div class="containerPonencias" v-if="aislar">
      <div v-if="loading" class="loading-container">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="bloqueEdicion" v-for="ponencia in ponencias" :key="ponencia._id">
            <div>
              <div class="area">{{area(ponencia.area)}}</div>
            </div>
            <div class="contenido">
              <div class="linea1">
                {{ponencia.nombre}}
              </div>
              <div class="linea2">
                {{ponencia.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')}}
              </div>
              <div class="linea4">
                <div class="lineaResumen">
                  <p class="resumen">Resumen</p>
                  <p class="up" @click="verResumen(ponencia._id)" v-show="!resumenesVisibles.some(e => e === ponencia._id)">&dtrif;</p>
                  <p class="down" v-show="resumenesVisibles.some(e => e === ponencia._id)" @click="ocultarResumen(ponencia._id)">&utrif;</p>
                </div>
                <p v-show="resumenesVisibles.some(e => e === ponencia._id)">{{ponencia.resumen}}</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  // components: { XCerrarModal },
  name: 'ShowCongPonen',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getCongresos()
  },
  emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      visible: false,
      congresos: [],
      ponencias: [],
      aislar: false,
      resumenesVisibles: [],
      desplegado: false,
      base: '',
      loading: false,
      meses:
        ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
          'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      areas: ['Antropoespeleología', 'Bioespeleología', 'Geoespeleología', 'Otras']
    }
  },
  methods: {
    cerrarModal: function () {
      this.$router.go(-1)
    },
    async getCongresos () {
      try {
        const url = `${this.URLbase}/congresos/getCongresos`
        const res = await fetch(url)
        this.congresos = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    async getPonencias (CongId) {
    //   if (!CongId) { return }
      try {
        this.loading = true
        const url = `${this.URLbase}/ponencias/getPonencias`
        const idCong = { _id: CongId }
        const res = await axios.post(url, idCong)
        this.ponencias = await res.data
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    aislarCongreso (idCongreso) {
      this.aislar = true
      this.idCongreso = idCongreso
      this.$emit('scrollHidden')
      this.getPonencias(idCongreso)
    },
    retornoCongreso () {
      this.aislar = false
      this.$emit('NoScrollHidden')
    },
    mes (numMes) {
      return this.meses[numMes - 1]
    },
    area (numArea) {
      return this.areas[numArea - 1]
    },
    verResumen (ID) {
      this.resumenesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    ocultarResumen (ID) {
      this.resumenesVisibles = this.resumenesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    }
  },
  computed: {
    congresosShow () {
      return this.aislar ? this.congresos.filter(e => e._id === this.idCongreso) : this.congresos
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99.9%;
  width: 100%;
  background-color: var(--gr-fo-for);
  margin-top: 2px;
}
.pubRow{
  /* height: 50px; */
  display: flex;
  width:100%;
  margin-top: 2px;
  flex-wrap: wrap;
  background-color: rgb(238, 228, 198);
  /* border: solid 1px rgb(255, 169, 30); */
}
.organizador{
  background-color: rgb(0, 68, 88);
  width: 25%;
  padding: 4px;
  font-size: 14px;
}
.restoDatos{
  display: flex;
  /* flex-direction: column; */
  justify-content:center;
  /* align-items: flex-start; */
  border-bottom: solid 0.5px rgb(0, 68, 88);
  width: 70%;
}
.datosCong{
  width:90%;
}
.nombre{
  font-family: SegoeBI;
  color: rgb(1, 56, 82);
  padding-left: 4px;
  padding-top: 4px;
  text-align: left;
}
.line2{
  padding-left: 4px;
  color: rgb(1, 56, 82);
  font-size: 14px;
  text-align: left;
}
.containerPonencias{
  height: 85%;
  margin-top: 3px;
  overflow-y: auto;
  background-color: rgba(251, 246, 234, 0.8);
  color:rgb(2, 2, 2);
}
.bloqueEdicion{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.area{
  /* width: 120px;
  height: 170px; */
  font-size: 80%;
  color: white;
  background-color: rgb(59, 133, 186);
  border-radius: 4px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
  margin: 0px 12%;
  padding-bottom:2px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 15px;
  margin-bottom: 0px;
}
.linea1{
  text-align: left;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.linea2, .linea3{
  font-size: 15px;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(1, 56, 82)
}
.linea4 p{
  text-align: left;
}
.lineaResumen{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.resumen{
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.up, .down{
  cursor:pointer;
  font-size: 30px;
}
.selector, .retorno{
  color: rgb(0, 137, 200);
  font-size: 20px;
  font-weight: bolder;
  cursor: pointer;
  height: 16px;
  width: 16px;
  align-self: center;
  padding-bottom: 8px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width: 576px){
 .containerMod{
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .bloqueFicha{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%
  }
  .organizador{
    width:100%;
  }
  .restoDatos{
    width: 100%;
    border-bottom: none;
  }
  .linea1, .linea2, .linea3, .linea4{
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
  }
  .linea2{
    /* font-size: 14px; */
    margin-top: 6px;
    font-weight: 600;
}
  .containerEdiciones{
    width: 90%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .area{
  width: 50%;
  /* height: 170px; */
  font-size: 100%;
  padding-bottom:2px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom:13px;
  margin-top: 8px;
  }
  .up, .down{
    margin:  2px 4px 0;
  }
}
</style>
